import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { DateService } from "@app/services/date.service";
import './date-cell.component.scss';

@Component({
    selector: 'date-cell',
    template: require('./date-cell.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateCell implements OnInit {
    @Input() date: Date;
    @Input() showErrorIfBeforeDate: Date;
    @Input() showWarningIfBeforeDate: Date;
    @Input() showRelativeTime: boolean;
    @Input() dateTime: boolean = true;

    // ---

    error: boolean;
    warning: boolean;

    constructor(private readonly dateService: DateService) {
    }

    ngOnInit(): void {
        if (this.showErrorIfBeforeDate && this.dateService.date1IsAfterDate2(this.showErrorIfBeforeDate, this.date)) {
            this.error = true;
        }

        if (this.showWarningIfBeforeDate && this.dateService.date1IsAfterDate2(this.showWarningIfBeforeDate, this.date) && !this.error) {
            this.warning = true;
        }
    }
}
